import styled from 'styled-components';
import { Button, Col } from '@workramp/ui';

export const TableEmptyStateContainer = styled.div`
  padding-top: ${({ theme }) => theme.spacing(24)}px;
  padding-bottom: ${({ theme }) => theme.spacing(24)}px;
  text-align: center;
`;

export const StyledCol = styled(Col)`
  padding-right: ${({ theme }) => theme.spacing(0)}px;
`;

export const StyledButton = styled(Button)`
  margin-left: ${({ theme }) => theme.spacing(2)}px;

  & > span > span {
    font-size: 0.75rem;
  }
`;
